import { useMutation } from "@tanstack/react-query";
import { Button, Form, Modal, Select, message } from "antd";
import React, { useState } from "react";
import { removeSubscription } from "../utils/api";

const Remove = ({
  id,
  type,
  refech,

  subs,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation(
    async (values) => await removeSubscription(values),
    {
      onSuccess: () => {
        message.success(`Added`);
        refech();
      },
      onError: (err) => {
        message.error(err?.response?.data?.message);
      },
    }
  );

  return (
    <div>
      {contextHolder}
      <Button
        type="primary"
        onClick={() => setVisible(true)}
        style={{
          marginTop: 10,
          width: "100%",
        }}
      >
        Remove
      </Button>
      <Modal
        title={"Add Subscription"}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 9 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          onFinish={(values) => {
            console.log(values);

            mutate({
              ...values,
              type: type,
              [type === "Music" ? "albumId" : "movieId"]: id,
            });
          }}
        >
          <Form.Item label="Subscription" name="subscriptionId" required>
            <Select placeholder="Select Subscription">
              {subs?.map((item) => (
                <Select.Option key={item._id} value={item._id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default Remove;
